import { fetchConfig } from '@theme/utilities';

const COOKIE_NAME = '_click_touches';
const COOKIE_MAX_AGE_DAYS = 30;
const MAX_TOUCHES = 50;

/**
 * @param {string} name
 * @returns {string | null}
 */
function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * @param {string} name
 * @param {string} value
 * @param {number} days
 */
function setCookie(name, value, days) {
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${days * 24 * 60 * 60}; path=/`;
}

/** @returns {Array<Record<string, string | null>>} */
function getStoredTouches() {
  try {
    return JSON.parse(getCookie(COOKIE_NAME) || '[]');
  } catch {
    return [];
  }
}

/** @param {Array<Record<string, string | null>>} touches */
async function pushToCart(touches) {
  try {
    const config = fetchConfig('json', {
      body: JSON.stringify({ attributes: { [COOKIE_NAME]: JSON.stringify(touches) } }),
    });
    await fetch(Theme.routes.cart_update_url, config);
  } catch {
    // Best-effort — a failed attribution push shouldn't block browsing or checkout.
  }
}

function captureClickTouch() {
  const params = new URLSearchParams(location.search);
  const fbclid = params.get('fbclid');
  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');
  const campaignId = params.get('campaign_id');
  const adsetId = params.get('adset_id');
  const adId = params.get('ad_id');

  const hasTrackingData = fbclid || utmSource || utmMedium || campaignId || adsetId || adId;
  if (!hasTrackingData) return;

  let touches = getStoredTouches();

  touches.push({
    fbclid: fbclid || null,
    campaign_id: campaignId || null,
    adset_id: adsetId || null,
    ad_id: adId || null,
    utm_source: utmSource || null,
    utm_medium: utmMedium || null,
    landing_url: location.href,
    ts: new Date().toISOString(),
  });

  // Cap for cookie/payload hygiene, not a Shopify size limit. The first touch is
  // preserved on purpose — downstream attribution keys off it and it must never
  // be pushed out by later touches.
  if (touches.length > MAX_TOUCHES) {
    touches = [touches[0], ...touches.slice(-(MAX_TOUCHES - 1))];
  }

  setCookie(COOKIE_NAME, JSON.stringify(touches), COOKIE_MAX_AGE_DAYS);
  pushToCart(touches);
}

captureClickTouch();
